import { useState, useEffect } from 'react';

const useSpecialToken = () => {
  const [userName, setUserName] = useState<string>('Utilisateur');
  const [specialToken, setSpecialToken] = useState<string | null>(null);

  useEffect(() => {
    // Récupération des tokens depuis le localStorage
    const specialTokenAdmin = localStorage.getItem('specialTokenAdmin');
    const specialTokenDev = localStorage.getItem('specialTokenDev');
    const specialTokenSuperAdmin = localStorage.getItem('specialTokenSuperAdmin');
    const NameUser = localStorage.getItem('NameUser');
    if(NameUser){
    setUserName(NameUser);} else {setUserName('Utilisateur');}

    // Vérification et attribution du token spécial et du nom d'utilisateur
    if (specialTokenAdmin !== 'undefined') {
      setSpecialToken(specialTokenAdmin);
    } else if (specialTokenDev !== 'undefined') {
      setSpecialToken(specialTokenDev);
    } else if (specialTokenSuperAdmin !== 'undefined') {
      setSpecialToken(specialTokenSuperAdmin);
    } else {
      console.error('Aucun token spécial trouvé.');
    }
  }, []); // Empty dependency array ensures this effect runs only once after initial mount

  return { userName, specialToken };
};

export default useSpecialToken;

